// extracted by css-extract-rspack-plugin
export default {"listGridItem":"CX479","card":"BhcgL"};